import { faSun, faCloudSun, faCloudsSun, faClouds, faMoon, faCloudMoon, faCloudsMoon, faCloudDrizzle, faCloudShowers, faCloudShowersHeavy } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';


const DayCloudObsClass = [
  {okta: 0, name: 'clear-day', icon: faSun},
  {okta: 1, name: 'cloud-light-day', icon: faCloudSun},
  {okta: 4, name: 'cloud-moderate-day', icon: faCloudsSun},
  {okta: 7, name: 'cloud-heavy-day', icon: faClouds},
];

const NightCloudObsClass = [
  {okta: 0, name: 'clear-night', icon: faMoon},
  {okta: 1, name: 'cloud-light-night', icon: faCloudMoon},
  {okta: 4, name: 'cloud-moderate-night', icon: faCloudsMoon},
  {okta: 7, name: 'cloud-heavy-night', icon: faClouds},
];

const RainObsClass = [
  {mm: 0, name: 'rain-light', icon: faCloudDrizzle, string: 'Light Rain'},
  {mm: 1, name: 'rain-moderate', icon: faCloudShowers, string: 'Moderate Rain'},
  {mm: 5, name: 'rain-heavy', icon: faCloudShowersHeavy, string: 'Heavy Rain'},
];

function findClassMatch(fieldName, value, classArray) {
  let bestMatch = classArray[0];
  
  for (const cls of classArray) {
    if (cls[fieldName] <= value) {
      bestMatch = cls;
      break;
    }
  }
  
  return bestMatch;
}

export function determineObservationClass(observation, change) {
  if (!observation && !change) {
    return null;
  }

  // TODO: handle night time classes when solar info is available
  if (change.rainfall10mins !== null && change.rainfall10mins > 0) {
    const classMatch = findClassMatch('mm', change.rainfall10mins, RainObsClass);
    return {
      name: classMatch.name,
      icon: classMatch.icon,
      description: classMatch.string,
    };
  } else {
    const classMatch = findClassMatch('okta', observation.cloud_oktas, DayCloudObsClass); 
    return {
      name: classMatch.name,
      icon: classMatch.icon,
      description: observation.cloud_obs,
    }
  }
}
